<script setup>
import {onMounted, ref} from "vue";
import {ElMessage, ElNotification} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import http from "@/http";

const router = useRouter();
const route = useRoute();
const store = useStore();

const formRef = ref();
const loading = ref(false);
const form = ref({
  id: null,
  title: {
    uz_lat: null,
    uz_cyr: null,
    ru: null,
    kr: null,
    en: null
  },
  asbo_id: null,
  inn: null,
  logo: null,
  is_active: false,
  is_archive: false
});
const uploadUrl = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
const uploadHeader = {Authorization: `${store.state.accessToken}`};
const indicatorFiles = ref([]);
const baseUrl = process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/";

const rules = ref({
  title: {
    uz_lat: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
    uz_cyr: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
    ru: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
    kr: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
    en: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}]
  },
  asbo_id: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
  inn: [{required: true, message: 'Majburiy maydon', trigger: 'blur'}],
})

const onSuccessUpload = (res) => {
  form.value.logo = res.hashId;
  loading.value = false
};
const onErrorUpload = (error) => {
  if (error.status === 401) {
    store.commit('signOut')
    router.push({name: "Auth"});
  }
  ElNotification.error({
    message:
        JSON.parse(error?.message)?.message ||
        "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
    type: "error",
  });
  loading.value = false;
};
const getIndicatorById = () => {
  loading.value = true
  http({url: `api/v1/indicators/organizations/${form.value.id}`})
      .then(({data}) => {
        form.value = data;
        indicatorFiles.value = [{name: '', url: baseUrl + data.logo}]
      })
      .catch((err) => {
        ElMessage.error(err.response.data.message || `Hatolik qayta urinib ko'ring`);
      })
      .finally(() => {
        loading.value = false;
      });
}
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/indicators/organizations${form.value.id ? `/${form.value.id}` : ""}`,
        data: form.value,
        method: form.value.id ? "put" : "post"
      })
          .then(() => {
            router.go(-1);
          })
          .catch((err) => {
            ElMessage.error(err.response.data.message || `Hatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            loading.value = false;
          });
    }
  })
};

onMounted(() => {
  if (route.params.id) {
    form.value.id = route.params.id;
    getIndicatorById()
  }
})
</script>

<template>
  <el-row class="add-news">
    <el-col :xs="24" :sm="24" :md="16" :lg="14" :xl="12">
      <el-form size="large" label-position="top" :rules="rules" ref="formRef" :model="form">
        <fieldset class="title">
          <legend>Nomi</legend>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item label="O'zbekcha nomi" prop="title.uz_lat">
                <el-input v-model="form.title.uz_lat"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item label="Krilcha nomi" prop="title.uz_cyr">
                <el-input v-model="form.title.uz_cyr"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item label="Ruscha nomi" prop="title.ru">
                <el-input v-model="form.title.ru"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item label="Inglizcha nomi" prop="title.en">
                <el-input v-model="form.title.en"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item label="Qoraqalpoqcha nomi" prop="title.kr">
                <el-input v-model="form.title.kr"/>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <el-row :gutter="10" class="mt-15">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="Asbo Id" prop="asbo_id">
              <el-input v-model="form.asbo_id"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="STIR" prop="inn">
              <el-input v-model="form.inn"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-space>
              <el-form-item label="Holati" prop="is_active">
                <el-checkbox border v-model="form.is_active">
                  {{ form.is_active ? 'Aktiv' : 'Aktiv emas' }}
                </el-checkbox>
              </el-form-item>
              <el-form-item label="Holati" prop="is_archive">
                <el-checkbox border v-model="form.is_archive">
                  {{ form.is_archive ? 'Arxiv' : 'Arxiv emas' }}
                </el-checkbox>
              </el-form-item>
            </el-space>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
            <el-form-item label="Rasim">
              <el-upload
                  style="width: 100%"
                  v-loading="loading"
                  ref="uploadRef"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  v-model:file-list="indicatorFiles"
                  :multiple="false"
                  accept="image/png,image/jpg,image/jpeg"
                  :limit="1"
                  list-type="picture"
                  :on-success="onSuccessUpload"
                  :on-error="onErrorUpload"
              >
                <template #trigger>
                  <el-button :disabled="indicatorFiles.length>=1" style="width: 100%" type="primary">
                    Indikator rasmini yuklang
                  </el-button>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="mt-15 text-right">
          <el-button @click="$router.go(-1)" class="el-button el-button--danger">
            Bekor qilish
          </el-button>
          <el-button type="primary" @click="submitForm(formRef)"
          >Saqlash
          </el-button
          >
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
.title {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
}

.text-right {
  text-align: right;
}
</style>
